export default function DifferentiatorSection() {
  return (
    <section className="py-20 px-6 bg-[#1A1208]">
      <div className="max-w-6xl mx-auto">
        {/* Label */}
        <div className="text-center mb-4">
          <span className="text-[#E8603C] text-sm font-semibold tracking-wider uppercase">
            Why This Wins
          </span>
        </div>

        {/* Title */}
        <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6 text-center">
          Other products give you designs.<br />
          This gives you the words too.
        </h2>

        {/* Subtitle */}
        <p className="text-lg text-gray-400 text-center max-w-3xl mx-auto mb-16">
          Most template packs stop at the visual. The Realtor Content Engine includes your captions and reel hooks — written and ready to post. Zero blank page. Zero guesswork.
        </p>

        {/* Visual Comparison */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="w-12 h-12 rounded-full bg-gray-600 flex items-center justify-center mx-auto mb-6">
              <i className="ri-close-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4 text-center">Other Template Packs</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-3">
                <span className="text-gray-600 mt-1">•</span>
                <span>Just the design files</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-gray-600 mt-1">•</span>
                <span>You write all the captions</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-gray-600 mt-1">•</span>
                <span>No posting strategy</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-gray-600 mt-1">•</span>
                <span>Still wondering what to post</span>
              </li>
            </ul>
          </div>

          <div className="bg-[#E8603C]/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-[#E8603C]">
            <div className="w-12 h-12 rounded-full bg-[#E8603C] flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4 text-center">The Realtor Content Engine</h3>
            <ul className="space-y-3 text-gray-200">
              <li className="flex items-start gap-3">
                <span className="text-[#E8603C] mt-1 font-bold">✓</span>
                <span className="font-medium">30 templates + 30 captions</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#E8603C] mt-1 font-bold">✓</span>
                <span className="font-medium">30 reel hook scripts included</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#E8603C] mt-1 font-bold">✓</span>
                <span className="font-medium">Full 30-day posting calendar</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#E8603C] mt-1 font-bold">✓</span>
                <span className="font-medium">Know exactly what to post daily</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}